import * as React from 'react';
// import { getCleanExpiryDate } from 'helpers/date-helper';
import { getI18n } from 'services/i18n-service';
import { InfoIconPopup } from '../info-icon/popup';
// import { MasterDataProductName } from 'components/master-data';
import { Props } from './props';
import { translations } from 'types/translations';

import './styles.css';

export class MobileProductDetailsCell extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const i18n = getI18n();
    const cell = (
      <span className="product-cell-details mobile">
        <span className="product-code">
          <span className="title">{this.props.operationItem.epc.primaryPropName}:&nbsp;</span>
          <span className="value">{this.props.operationItem.epc.primaryPropValue}</span>
        </span>
        <span className="serial">
          <span className="title">{i18n.t(translations.SerialNumber)}:&nbsp;</span>
          <span className="value">{this.props.operationItem.epc.rawCode}</span>
        </span>
      </span>
    );
    return (
      <InfoIconPopup operationItem={this.props.operationItem} trigger={cell} language={this.props.language}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/cells/product-details/mobile-items.tsx